import React from 'react'
import Button from '../common/Button'
import { getFilters, setFilters } from '@/store/slices/speakersSlice'
import { useDispatch, useSelector } from 'react-redux'

const Categories = ({ label = '', categories = [], speakerData }) => {
  const dispatch = useDispatch()
  const filters = useSelector(getFilters)

  const handleCategoryChange = (category) => {
    const selecteCategory = speakerData?.[0]?.speakersTopics.filter(
      (item) => item.name == category.name
    )
    const result = []
    result.push(selecteCategory[0].id)
    dispatch(
      setFilters({
        ...filters,
        types: null,
        categories: null,
        searchQuery: '',
        profileCategory: selecteCategory[0]?.id,
        relatedSpeakers: null,
        sortOrder: null,
      })
    )
  }
  return (
    <>
      <div className="flex justify-center mb-10 text-2xl uppercase tagline-font md:mb-10">
        {label}
      </div>
      <div className="flex flex-wrap justify-center px-6 xl:px-16 lg:px-0">
        {categories.map((category, index) => {
          return (
            <a
              target="_blank"
              key={index}
              href={`/speakers/topics/${category?.slug}`}
              rel="noreferrer"
              onClick={() => handleCategoryChange(category)}
            >
              <Button
                className="px-3 mx-2 mb-4 text-sm bg-black border cursor-pointer md:px-4 h-11 lg:mx-3 lg:mb-7 md:mx-3 md:mb-4 button-hover"
                label={category.name}
              />
            </a>
          )
        })}
      </div>
    </>
  )
}

export default Categories
